export enum TypePlanningEnum {
  STRUCTURE = 'STRUCTURE',
  PLC = 'PLC'
}